import { orderStatusAddressDetailsStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusAddressDetails";
import { TYPOGRAPHY } from "@store/theme/common/design";
import { checkoutBlockSubTitleStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(orderStatusAddressDetailsStyles, {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
    shippingAddressWrapper: {
        css: css`
            margin-right: 40px;
        `,
    },
    titleText: {
        variant: "h4",
        css: css`
            ${checkoutBlockSubTitleStyles()}
            margin-bottom: 5px;

            @media print {
                font-size: ${TYPOGRAPHY.size.tiny};
            }
        `,
    },
});
